import { render } from "./message-tool.vue?vue&type=template&id=adfa2344&scoped=true&ts=true"
import script from "./message-tool.vue?vue&type=script&lang=ts"
export * from "./message-tool.vue?vue&type=script&lang=ts"

import "./message-tool.vue?vue&type=style&index=0&id=adfa2344&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adfa2344"]])

export default __exports__